import bUtils from 'babyeye-utils'
import router from '@/router'

const DISTANCE = 0.2

// 根getter
const getters = {
  distance: () => 0.2,
  // ratio :  标准 / 目前
  // 单位棱镜转化为像素
  rowScale: state => ((185 * state.settings.ratio) / 50) * 10,

  singlePixel_prism: state =>
    // 屏幕单位像素长度（棱镜度）
    // rowScale / DISTANCE
    5 / (DISTANCE * (185 * state.settings.ratio)),
  prim2px: (state, getters) => prim => {
    let { distance, rowScale } = getters
    return (prim * distance * rowScale) << 0
  },
  goToHome: state => () => {
    if (state.app.brand) {
      router.push(state.app.brand.home || '/')
      return
    }
    router.push('/')
  },
  goToD5: state => () => {
    window.open(process.env.VUE_APP_D5_URL + '?token=' + state.user.token)
  },
  goToExamine: state => () => {
    const user = state.user
    const userInfo = {
      ...user.userInfo,
      username: user.curPatient.fullName,
      gender: user.curPatient.gender,
      age: user.curPatient.age,
      uid: user.curPatient.uid,
    }
    const baseUrl = process.env.VUE_APP_EXAMINE_URL
    // const path = decodeURIComponent(bUtils.addParamsToUrl(baseUrl, userInfo))
    const path = `${baseUrl}?token=${state.user.token}`
    console.log(path,'path')
    window.open(path)
  },

  horiRangeMin: (state, getters) => {
    let rangeMin = state.therapy.vergence.horizontal.range[0]
    return (rangeMin * DISTANCE * getters.rowScale) << 0
  },
  horiRangeMax: (state, getters) => {
    let rangeMax = state.therapy.vergence.horizontal.range[1]
    return (rangeMax * DISTANCE * getters.rowScale) << 0
  },
  horiSpeed: (state, getters) => {
    let speed = state.therapy.vergence.horizontal.speed
    console.log(speed, 'speed')
    return (speed * DISTANCE * getters.rowScale) << 0
  },
  horiStep: (state, getters) => {
    let step = state.therapy.vergence.horizontal.step
    return (step * DISTANCE * getters.rowScale) << 0
  },
  hospitalType: state => state.user.userInfo.hospitalType,
}

export default getters
